.container {
  position: relative;
  width: 100%;
  margin-bottom: 1.5rem;
}

.searchWrapper {
  display: flex;
  align-items: center;
  border-radius: 0.375rem;
  background-color: var(--cxy-color-search-input);
  overflow: hidden;
}

.searchWrapper.dark {
  border-color: #262626;
}

.iconContainer {
  padding: 0.5rem 0.75rem;
}

.icon {
  color: var(--cxy-color-content-default);
}

.iconDisabled {
  color: #9ca3af;
}

.tagsContainer {
  flex-grow: 1;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.25rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0;
  padding-right: 0.5rem;
}

.tag {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--cxy-color-brand);
  color: var(--cxy-color-content-dark);
  border-radius: 9999px;
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.tagSelected {
  background-color: var(--cxy-color-brand);
  ring: 2px solid var(--cxy-color-brand);
  box-shadow: 0 0 0 2px var(--cxy-color-brand);
}

.tagButton {
  margin-left: 0.25rem;
  color: #00182e;
}

.input {
  flex-grow: 1;
  outline: none;
  padding-right: 0.5rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  background-color: transparent;
  color: var(--cxy-color-content-default);
  font-size: 1rem;
  line-height: 1.5rem;
}

.input::placeholder {
  color: var(--cxy-color-content-default);
  opacity: 0.8;
}

.inputCaretHidden {
  caret-color: transparent;
}

.clearContainer {
  display: flex;
  align-items: center;
  padding: 0.5rem 0.75rem;
}

.clearButton {
  margin-left: 0.25rem;
  color: #00182e;
}

.clearIcon {
  color: white;
}

/* Gazzetta theme overrides */
[data-fpsm-theme='gazzetta'] {
  .input::placeholder {
    color: var(--cxy-color-grey-250);
    opacity: 1;
  }

  .tagButton {
    color: var(--cxy-color-white);
  }

  .clearIcon {
    color: var(--cxy-color-black);
  }
}
